



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import FeeTable from './feeTable.vue'
import LawsuitApi from '@/api/lawsuit'
import { zeroUnit } from '@/web-task/utils'
import { format } from '@/web-task/filter'
import {
	DAI_DIAO_DU,
	DAI_QUE_REN_LAW,
	DAI_JIE_DAN,
	ZUO_YE_ZHONG,
} from '@/web-task/config.ts'

@Component({
	components: {
		InfoRow,
		FeeTable,
	},
})
export default class litigationPlan extends Vue {
	private planList: any = []

	@Prop()
	private order!: any

	private get hasSetBtn() {
		return (
			[DAI_DIAO_DU, DAI_QUE_REN_LAW, DAI_JIE_DAN, ZUO_YE_ZHONG].includes(
				this.order.orderStatus
			) && this.order.creator === this.$store.state.user.userInfo.userId
		)
	}

	private get settingList() {
		return this.planList.map((item: any) => {
			return [
				{
					label: '设置人',
					value: item.creatorName,
				},
				{
					label: '联系方式',
					value: item.creatorPhone,
				},
				{
					label: '设置时间',
					value: format(new Date(item.createTime), 'YYYY-MM-DD HH:mm'),
				},
				{
					label: '应诉方案赔付总金额',
					value: zeroUnit(item.compensationSum, '元'),
				},
			]
		})
	}

	private toSetLitigationPlan() {
		this.$multiTab.close(
			`/lawsuit/setLitigationPlan/${this.$route.params.orderId}`
		)
		this.$nextTick(() => {
			this.$router.push({
				name: 'setLitigationPlan',
				params: {
					orderId: this.$route.params.orderId,
				},
			})
		})
	}

	private getPlanList() {
		if (this.$route.params.orderId) {
			LawsuitApi.getPlanList(this.$route.params.orderId).then((res: any) => {
				this.planList = res.data || []
			})
		}
	}

	private created() {
		this.getPlanList()
	}
}
